export enum PublishStateEnum {
    Published = 0,
    NotPublished = 1,
    Deprecated = 2
}